import { createAsyncThunk } from "@reduxjs/toolkit";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";

export const fetchInventoryPurchaseOrderGRN = createAsyncThunk(
  "inventory/fetchInventoryPurchaseOrderGRN",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());

      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters?.length > 0) {
        filters.forEach(({ filterField, filterValue }: any) => {
          if (filterField && filterValue !== null) {
            if (typeof filterValue === "object") {
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== "") params.append(key, String(value));
              });
            } else {
              params.append(filterField, String(filterValue));
            }
          }
        });
      } 

      const response = await WarehouseAxios.get(
        `/item/grn-list/?${params.toString()}`
      );

      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } catch (error: any) {
      console.error("fetch Purchase Order GRN List error:", error);
      throw new Error("Network Error");
    }
  }
);


export const fetchGRNViewdetailsDataById = createAsyncThunk<any, string>(
  "fetch/fetchGRNViewdetailsDataById",  
  async (grn_details_id, { rejectWithValue }) => {
    try {
      const response = await WarehouseAxios.get(`/item/grn-details/${grn_details_id}/`);
      return response?.data?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Failed to fetch GRN details");
    }
  }
);  
